import { Container, ContainerModule } from 'inversify';

import {
  AssessmentWorkflowStore,
  AuthStore,
  ConversationsHistoryStore,
  CounterStore,
  LocalStorageStore,
  StreamingStore,
} from '@stores';

import { DI_TOKENS } from '../constants';

const uiContainer: ContainerModule = new ContainerModule(({ bind }) => {
  bind<LocalStorageStore>(DI_TOKENS.LocalStorageStore).to(LocalStorageStore).inSingletonScope();
  bind<CounterStore>(DI_TOKENS.CounterStore).to(CounterStore).inSingletonScope();
  bind<ConversationsHistoryStore>(DI_TOKENS.ConversationsHistoryStore)
    .to(ConversationsHistoryStore)
    .inSingletonScope();
  bind<AuthStore>(DI_TOKENS.AuthStore)
    .toDynamicValue((context) => {
      const ls = context.get<LocalStorageStore>(DI_TOKENS.LocalStorageStore);
      return new AuthStore(ls);
    })
    .inSingletonScope();
  bind<StreamingStore>(DI_TOKENS.StreamingStore).to(StreamingStore).inSingletonScope();
  bind<AssessmentWorkflowStore>(DI_TOKENS.AssessmentWorkflowStore)
    .to(AssessmentWorkflowStore)
    .inSingletonScope();
});

export const container = new Container();
container.load(uiContainer);
